/* eslint-disable import/no-cycle */
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reduxWebsocket from '@giantmachines/redux-websocket';
import throttle from 'lodash/throttle';
import uuidv4 from 'uuid';
import {
  WEBSOCKET_STATUS_NOT_CONNECTED, WEBSOCKET_PREFIX, PATH, DIALOG,
} from 'shared/constants';
// import english from 'shared/translations/en.json';
import arabic from 'shared/translations/ar.json';
import rootReducer from '../reducers';
import { loadState, saveState } from './localStorage';

const persistedState = loadState();

export const initialState = {
  rootReducer: {
    investorConversations: persistedState && persistedState.investorConversations ? persistedState.investorConversations : [],
    riskAssessment: persistedState && persistedState.riskAssessment ? persistedState.riskAssessment : [],
    investmentPreference: persistedState && persistedState.investmentPreference ? persistedState.investmentPreference : [],
    callToAction: [],
    stopThread: null,
    currentThread: null,
    vars: null,
    websocketStatus: WEBSOCKET_STATUS_NOT_CONNECTED,
    connectCount: null,
    language: { locale: 'AR', messages: arabic },
    isBotTyping: 0,
    summary: persistedState && persistedState.summary ? persistedState.summary : {},
    CMAClassification: persistedState && persistedState.CMAClassification ? persistedState.CMAClassification : 'CMAClassification.Qualified',
    step: {
      active: 1,
      status: 'default',
    },
    user: uuidv4(), // this user key is raleted to botkit channel. pls do not change this.
    userInfo: persistedState && persistedState.userInfo ? persistedState.userInfo : { },
    stepStatus: [{
      step: DIALOG.INVESTOR_PROFILE,
      number: 1,
      active: true,
      status: null,
      title: 'journey.step1Title',
      desc: 'journey.step1Desc',
      path: PATH.INVESTOR_PROFILE,
    },
    {
      step: DIALOG.RISK_ASSESSMENT,
      number: 2,
      active: false,
      status: null,
      title: 'journey.step2Title',
      desc: 'journey.step2Desc',
      path: PATH.RISK_ASSESSMENT,
    },
    {
      step: DIALOG.INVESTMENT_PREFERENCE,
      number: 3,
      active: false,
      status: null,
      title: 'journey.step3Title',
      desc: 'journey.step3Desc',
      path: PATH.INVESTMENT_PREFERENCE,
    }],
    isStartStep: persistedState && persistedState.isStartStep ? persistedState.isStartStep : false,
    redo: persistedState && persistedState.redo ? persistedState.redo : '',
  },
  fundFactsheetReducer: {
    funds: persistedState && persistedState.funds ? persistedState.funds : [],
    // fundDetail: [],
  },
  assetAllocations: {
    assetAllocation: [],
    assetAllocationDetails: [],
    isinCodes: [],
    tacticleAsset: [],
  },
  goalSummaryResults: {
    currency: 'KWD',
    highInvestmentValue: 0,
    lowInvestmentValue: 0,
    messageResultCode: '',
    messageResultTextArabic: '',
    messageResultTextEn: '',
    period: 0,
  },
  ctaReducer: {
    submitAppointmentPending: false,
    submitAppointmentSuccess: false,
    submitAppointmentFailure: false,
    submitAppointmentError: null,
    referenceCode: '',
  },
};

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
/* eslint-enable */

const websocketMiddleware = reduxWebsocket({
  prefix: WEBSOCKET_PREFIX,
  // reconnectInterval: 5,
  reconnectOnClose: true,
  onOpen: (socket) => {
    window.__socket = socket; // eslint-disable-line no-underscore-dangle
  },
});

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(thunkMiddleware, websocketMiddleware)),
  persistedState,
);

/**
 * To Sync to local storage, uncomment items below or add a new one you want to sync
 */
store.subscribe(throttle(() => {
  saveState({
    summary: store.getState().rootReducer.summary,
    userInfo: store.getState().rootReducer.userInfo,
    CMAClassification: store.getState().rootReducer.CMAClassification,
    redo: store.getState().rootReducer.redo,
    isStartStep: store.getState().rootReducer.isStartStep,
    funds: store.getState().fundFactsheetReducer.funds,
    // investorConversations: store.getState().investorConversations,
    // riskAssessment: store.getState().riskAssessment,
    // investmentPreference: store.getState().investmentPreference,
  });
}, 1000));

export default store;
